import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchTermHolidayPeriod, createTermHolidayPeriod, updateTermHolidayPeriod } from './actions';
import TermHolidayPeriodSettingsForm from './SettingsForm';
import { Panel } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleTermHolidayPeriodSettingsSubmit = this.handleTermHolidayPeriodSettingsSubmit.bind(this);
		this.handleSendHolidayReminderChange = this.handleSendHolidayReminderChange.bind(this);
		this.state = {
			sendHolidayReminder: false
		};
	}

	componentDidMount() {
		const { match, fetchTermHolidayPeriod } = this.props;
		const termHolidayPeriodId = match.params.id;

		if (termHolidayPeriodId) {
			fetchTermHolidayPeriod(termHolidayPeriodId);
		}
	}

	componentWillReceiveProps(nextProps) {
		const nextHoliday = nextProps.termHolidayPeriod;

		if (nextHoliday && nextHoliday.sendHolidayReminder && !this.state.sendHolidayReminder) {
			this.setState({ sendHolidayReminder: nextHoliday.sendHolidayReminder });
		}
	}

	handleTermHolidayPeriodSettingsSubmit(values) {
		const { termId, termHolidayPeriod, createTermHolidayPeriod, updateTermHolidayPeriod, history } = this.props;
		if (termId) {
			Object.assign(values, { termId });
		}
		if (termHolidayPeriod) {
			updateTermHolidayPeriod(termHolidayPeriod.id, values);
		} else {
			createTermHolidayPeriod(values, history);
		}
	}

	handleSendHolidayReminderChange(event, sendHolidayReminder) {
		this.setState({ sendHolidayReminder });
	}

	render() {
		const { termId, match, termHolidayPeriod, isReadonly, t } = this.props;
		let initialValues = termHolidayPeriod;

		if (!initialValues) {
			initialValues = { skipWeek: true };
		}

		return <Panel>
			<Panel.Heading>{t('Common_Details')}</Panel.Heading>
			<Panel.Body>
				<TermHolidayPeriodSettingsForm termId={termId} form={'termHolidayPeriod'} isReadonly={isReadonly} onSubmit={this.handleTermHolidayPeriodSettingsSubmit} initialValues={initialValues}
					onSendHolidayReminderChange={this.handleSendHolidayReminderChange} sendHolidayReminder={this.state.sendHolidayReminder} />
			</Panel.Body>
		</Panel>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const termHolidayPeriodId = ownProps.match.params.id;

	const {
		entities: { termHolidayPeriods }
	} = state;
	const termHolidayPeriod = termHolidayPeriods[termHolidayPeriodId];
	return {
		termHolidayPeriod,
		isReadonly: termHolidayPeriod && termHolidayPeriod.isReadonly
	};
};

const mapDispatchToProps = {
	fetchTermHolidayPeriod,
	createTermHolidayPeriod,
	updateTermHolidayPeriod,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Details));